import React from "react";
import "@/App.css";
import { ThemeProvider } from "./context/ThemeContext";
import Header from "./components/Header";
import Hero from "./components/Hero";
import Skills from "./components/Skills";
import Experience from "./components/Experience";
import Projects from "./components/Projects";
import GitHubActivity from "./components/GitHubActivity";
import Certifications from "./components/Certifications";
import Publications from "./components/Publications";
import Contact from "./components/Contact";
import Footer from "./components/Footer";

function App() {
  return (
    <ThemeProvider>
      <div className="App">
        <Header />
        <Hero />
        <Skills />
        <Experience />
        <Projects />
        <GitHubActivity />
        <Certifications />
        <Publications />
        <Contact />
        <Footer />
      </div>
    </ThemeProvider>
  );
}

export default App;
